{
  "name": "videojs",
  "type": "adapter",
  "tech": "js",
  "author": "NPAW",
  "version": "6.8.18",
  "built": "2024-04-09",
  "repo": "https://bitbucket.org/npaw/videojs-adapter-js.git",
  "libVersion": "^6.8.54",
  "features": {
    "buffer": "native",
    "seek": "native",
    "error": true,
    "stop": true,
    "pause": true,
    "resume": true,
    "getters": [
      "getPlayhead",
      "getPlayrate",
      "getDuration",
      "getBitrate",
      "getRendition",
      "getTitle",
      "getIsLive",
      "getResource",
      "getPlayerVersion"
    ]
  },
  "ads": [
    {
      "buffer": "monitor",
      "seek": "monitor",
      "error": true,
      "stop": true,
      "pause": true,
      "resume": true,
      "getters": [
        "getPlayhead",
        "getDuration",
        "getTitle",
        "getResource",
        "getPosition",
        "getGivenBreaks",
        "getBreaksTime",
        "getGivenAds",
        "getIsVisible",
        "getAudioEnabled",
        "getIsSkippable",
        "getIsFullscreen",
        "getCreativeId"
      ],
      "filename": "bcove-freewheel.js"
    },
    {
      "buffer": "monitor",
      "seek": "monitor",
      "error": true,
      "stop": true,
      "pause": true,
      "resume": true,
      "getters": [
        "getPlayhead",
        "getDuration",
        "getBitrate",
        "getTitle",
        "getResource",
        "getPlayerVersion",
        "getPosition",
        "getGivenBreaks",
        "getBreaksTime",
        "getGivenAds",
        "getIsVisible",
        "getAudioEnabled",
        "getIsSkippable",
        "getIsFullscreen",
        "getCreativeId"
      ],
      "filename": "bcove-ima.js"
    },
    {
      "buffer": "monitor",
      "seek": "monitor",
      "error": false,
      "stop": false,
      "pause": false,
      "resume": false,
      "getters": [],
      "filename": "freewheel.js"
    },
    {
      "buffer": "monitor",
      "seek": "monitor",
      "error": true,
      "stop": true,
      "pause": false,
      "resume": false,
      "getters": [],
      "filename": "generic.js"
    },
    {
      "buffer": "monitor",
      "seek": "monitor",
      "error": true,
      "stop": true,
      "pause": true,
      "resume": true,
      "getters": [
        "getPlayhead",
        "getDuration",
        "getTitle",
        "getIsLive",
        "getResource",
        "getPlayerVersion",
        "getPosition",
        "getGivenBreaks",
        "getBreaksTime",
        "getGivenAds",
        "getIsVisible",
        "getAudioEnabled",
        "getIsSkippable",
        "getIsFullscreen"
      ],
      "filename": "ima.js"
    },
    {
      "buffer": "monitor",
      "seek": "monitor",
      "error": true,
      "stop": true,
      "pause": true,
      "resume": true,
      "getters": [
        "getPlayhead",
        "getDuration",
        "getResource",
        "getPosition"
      ],
      "filename": "onceux.js"
    }
  ]
}